<template>
<div class="homepage">
    <el-dialog
      class="custom-modal-size"
      title="Filter"
      width="1100px"
      :visible.sync="getFilterModalVisible">
      <FilterDatas 
        :collection="collection" 
        :mode="'prod'" 
        :model="['id', 'name', 'type', 'tags']"
        :setQuery="queryFromSidebar"
        @filteredData="filteredLogs"></FilterDatas>
      <el-button @click="closeFilterModal">Fermer</el-button>
    </el-dialog>

    <el-card class="custom-margin-bottom ">
      <TopBarMiniCard
        :title="$t('products')"
        :cardLoaded="collection.length"
        :isLoaded="'isAllOperatorsLoaded'"
        @clickLoadMore="loadMoreData"
        @refresh="refreshData"
        @createNew="createNew"
      ></TopBarMiniCard>
    </el-card>

    <CardMiniProduct v-for="(product, idx) in filteredCollection" :key="idx" :product="product"></CardMiniProduct>

    <!-- start Modal for Create product form -->
    <el-dialog
      width="1200px"
      :visible.sync="dialogFormVisible"
      :modalAppendToBody="false">
        <CreateProductModal :key="dialogFormVisible" @closeForm="closeCreationForm"></CreateProductModal>
    </el-dialog>
    <!-- end Modal for Create product form -->
  </div>
</template>

<script>
import { productTable } from '../data/dynamoDBSimulation'
import CardMiniProduct from '@/components/CardMiniProduct.vue'
import TopBarMiniCard from '../components/TopBarMiniCard.vue'
import FilterDatas from '@/components/vuejs-components-collection/components-collection/FilterDatas.vue'
import CreateProductModal from '../components/product/CreateProductModal.vue'

export default {
  name: 'productionArea',
  components: {
    FilterDatas,
    CardMiniProduct,
    TopBarMiniCard,
    CreateProductModal
  },
  data() {
    return {
      filteredCollection: [],
      dialogFormVisible: false
    }
  },
  mounted() {
    this.$store.dispatch('getProducts');
    if(this.$store.getters.operators.length === 0) {
      this.$store.dispatch('getOperators');
    }
    if(this.$store.getters.productionZones.length === 0) {
      this.$store.dispatch('getProductionZones');
    }
    if(this.$store.getters.manufacturingOrders.length === 0) {
      this.$store.dispatch('getManufacturingOrders');
    }
  },
  created() {
    // this.filteredCollection = this.collection;
    this.filteredCollection = productTable;
  },
  watch: {
    collection: function() {
      this.filteredCollection = this.collection;
    }
  },
  computed : {
    collection() {
    //   return this.$store.getters.operators
      return productTable;
    },
    getFilterModalVisible: {
      get: function() {
        return this.$store.getters.getFilterModalVisible;
      },
      set: function() {
        return this.$store.dispatch('switchFilterModalVisible', false);
      }
    },
    queryFromSidebar() {
      return this.$store.getters.searchFavSelected;
    }
  },
  methods: {
    filteredLogs: function(event) {
      this.filteredCollection = event;
    },
    loadMoreData: function() {
      this.$store.dispatch('loadMoreProducts');
    },
    refreshData: function() {
      this.$store.dispatch('refreshProducts');
    },
    closeFilterModal: function() {
      this.$store.dispatch('switchFilterModalVisible');
    },
    createNew: function() {
      this.dialogFormVisible = true;
    },
    closeCreationForm: function() {
      this.dialogFormVisible = false;
    }
  }
}
</script>

<style lang="css" scoped>
  .homepage {
    min-width: 950px;
  }

  .custom-modal-size {
    margin: auto;
  }

  .custom-margin-bottom {
    margin-bottom: 20px;
  }

  .el-dialog {
    width: 1100px !important;
  }

</style>
